import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClientModule } from '@angular/common/http';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Globals } from './globals';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { CarouselModule } from 'ngx-owl-carousel-o';

import {MatIconModule} from '@angular/material/icon';
import {MatDividerModule} from '@angular/material/divider';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatMenuModule} from '@angular/material/menu';
import {MatDialogModule} from '@angular/material/dialog';
import {MatBadgeModule} from '@angular/material/badge';
import {MatTableModule} from '@angular/material/table';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatChipsModule} from '@angular/material/chips';

import {MdcElevationModule} from '@angular-mdc/web/elevation';
import {MdcRippleModule} from '@angular-mdc/web/ripple';
import {MdcButtonModule} from '@angular-mdc/web/button';
import {MdcIconModule} from '@angular-mdc/web/icon';
import {MdcIconButtonModule} from '@angular-mdc/web/icon-button';
import {MdcSnackbarModule} from '@angular-mdc/web/snackbar';
import {MdcDrawerModule} from '@angular-mdc/web/drawer';
import {MdcListModule} from '@angular-mdc/web/list';

import { TopBarComponent } from './componentes/top-bar/top-bar.component';
import { CatalogoListadoComponent } from './componentes/catalogo-listado/catalogo-listado.component';
import { ModalProductoDetalleComponent } from './componentes/modal-producto-detalle/modal-producto-detalle.component';
import { ModalCarritoProductosComponent } from './componentes/modal-carrito-productos/modal-carrito-productos.component';
import { ProductosCarritoComponent } from './componentes/productos-carrito/productos-carrito.component';
import { CotizarComponent } from './componentes/cotizar/cotizar.component';
import { CotizacionesClienteComponent } from './componentes/cotizaciones-cliente/cotizaciones-cliente.component';
import { CategoriasComponent } from './componentes/categorias/categorias.component';
import { PrecioTipoComponent } from './componentes/precio-tipo/precio-tipo.component';
import { MarcasComponent } from './componentes/marcas/marcas.component';
import { ModelosComponent } from './componentes/modelos/modelos.component';
import { ModalFiltroModelosComponent } from './componentes/modal-filtro-modelos/modal-filtro-modelos.component';
import { ModalFiltroTagsComponent } from './componentes/modal-filtro-tags/modal-filtro-tags.component';
import { BottomNavigationModule } from './bottom-navigation/bottom-navigation.module';
import { BuscadorProductosComponent } from './buscador-productos/buscador-productos.component';
import { MenuNuevoModule } from './menu-nuevo/menu-nuevo.module';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ModalDescargarProductosExcelComponent } from './modal-descargar-productos-excel/modal-descargar-productos-excel.component';
import { MatListModule } from '@angular/material/list';
import { VistaProductoComponent } from './componentes/vista-producto/vista-producto.component';
import { CommonModule } from '@angular/common';
import { ConfirmComponent } from './confirm/confirm.component';
import { ConfirmCancelCotizacionComponent } from './confirm-cancel-cotizacion/confirm-cancel-cotizacion.component';

@NgModule({
  declarations: [
    AppComponent,
    TopBarComponent,
    CatalogoListadoComponent,
    ModalProductoDetalleComponent,
    ModalCarritoProductosComponent,
    
    ProductosCarritoComponent,
    CotizarComponent,
    CotizacionesClienteComponent,
    CategoriasComponent,
    PrecioTipoComponent,
    MarcasComponent,
    ModelosComponent,
    ModalFiltroModelosComponent,
    ModalFiltroTagsComponent,
    BuscadorProductosComponent,
    ModalDescargarProductosExcelComponent,
    VistaProductoComponent,
    ConfirmComponent,
    ConfirmCancelCotizacionComponent,

  ],
  entryComponents: [
    ModalProductoDetalleComponent,
    ModalCarritoProductosComponent,
    ModalFiltroModelosComponent,
    ModalFiltroTagsComponent,
    ConfirmComponent,
  ],
  imports: [
    CommonModule,
    MatListModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    MenuNuevoModule,  

    BottomNavigationModule,
    
    HttpClientModule,
    
    FormsModule,
    ReactiveFormsModule,

    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatDialogModule,
    MatBadgeModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ClipboardModule,
    MatChipsModule,

    MdcElevationModule,
    MdcRippleModule,
    MdcButtonModule,
    MdcIconModule,
    MdcIconButtonModule,
    MdcSnackbarModule,
    MdcDrawerModule,
    MdcListModule,

    InfiniteScrollModule,

    CarouselModule,
    MatSnackBarModule
  ],
  providers: [
    Globals
  ],
  exports: [ModalDescargarProductosExcelComponent],// Asegúrate de tener esta exportación si necesitas utilizar el componente fuera de este módulo
  bootstrap: [AppComponent]
})
export class AppModule { }
